import { isEmpty } from "../../utils/lodash";
import { RandomizationModel } from "../RandomizationModel";
import { RandomizationPattern } from "../enums/RandomizationPattern";

export function createRandomization(el?: any): RandomizationModel {
    if (isEmpty(el)) return undefined;
    return {
        id: el.id,
        pattern: RandomizationPattern[el.pattern as string],
        bounds: el.bounds,
        seedAdjust: el.seedAdjust || el.id,
        groupCount: el.groupCount,
        synchronizedQuestion: el.synchronizedQuestion,
        synchronizedWithId: el.synchronizedWithId,
    };
}
